export function Notificacao(){
    return (
        <li className="nav-item dropdown">
            <a className="nav-link" data-toggle="dropdown" href="/#">
                <i className="far fa-bell"></i>
                <span className="badge badge-warning navbar-badge">0</span>
            </a>
            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                <span className="dropdown-item dropdown-header">0 Notificações</span>
                <div className="dropdown-divider"></div>
                <a href="/#" className="dropdown-item">
                    <i className="fas fa-envelope mr-2"></i> 0 novas mensagens
                    {/* <span className="float-right text-muted text-sm">3 mins</span> */}
                </a>
                <div className="dropdown-divider"></div>
                <a href="/#" className="dropdown-item">
                    <i className="fas fa-file mr-2"></i> 0 novos documentos
                    {/* <span className="float-right text-muted text-sm">2 days</span> */}
                </a>
                <div className="dropdown-divider"></div>
                <a href="/#" className="dropdown-item dropdown-footer">Ver todas as notificações</a>
            </div>
        </li>
    )
}